import { render, staticRenderFns } from "./HeadingRoof.vue?vue&type=template&id=0747e454&scoped=true&lang=pug&"
import script from "./HeadingRoof.vue?vue&type=script&lang=js&"
export * from "./HeadingRoof.vue?vue&type=script&lang=js&"
import style0 from "./HeadingRoof.vue?vue&type=style&index=0&id=0747e454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747e454",
  null
  
)

export default component.exports